import React, { FunctionComponent } from 'react'
import TextWithImage, {
  TextWithImageProps,
} from '../../../molecules/text-with-image/TextWithImage'
import { SectionProps } from '../Sections'

export interface TextWithImageSectionProps
  extends TextWithImageProps,
    SectionProps {}

const TextWithImageSection: FunctionComponent<TextWithImageSectionProps> = ({
  className,
  image,
  imageAlignment,
  lead,
  link,
  text,
  title,
}) => (
  <TextWithImage
    className={className}
    image={image}
    imageAlignment={imageAlignment || undefined}
    lead={lead}
    link={link}
    text={text}
    title={title}
  />
)

export default TextWithImageSection
